import React from "react";
import loadable from "@loadable/component";
import { getCmsServerSideProps } from "../pages/cms/index";

const CmsHome = loadable(() => import("../pages/cms/index"), {
  fallback: <div>loading...</div>,
});

let Routes = [
  // {
  //   getServerSideData: getCmsServerSideProps,
  //   path: "/cms",
  //   element: <CmsHome />,
  //   exact: true,
  // },
  // {
  //   getServerSideData: getCmsServerSideProps,
  //   path: "/cms/:path",
  //   element: <CmsHome />,
  //   exact: true,
  // },
  // {
  //   getServerSideData: getCmsServerSideProps,
  //   path: "/cms/:path/:param",
  //   element: <CmsHome />,
  //   exact: true,
  // },
  // {
  //   getServerSideData: getCmsServerSideProps,
  //   path: "/cms/:path/:param/:id",
  //   element: <CmsHome />,
  //   exact: true,
  // },
];

export default Routes;
